import emailjs from '@emailjs/browser';

// Initialize EmailJS (you'll need to add your public key)
const EMAILJS_PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY || 'YOUR_EMAILJS_PUBLIC_KEY';
const EMAILJS_SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID || 'YOUR_SERVICE_ID';
const WHITEPAPER_USER_TEMPLATE_ID = process.env.REACT_APP_EMAILJS_WHITEPAPER_USER_TEMPLATE_ID || 'YOUR_WHITEPAPER_USER_TEMPLATE_ID';
const ADMIN_TEMPLATE_ID = process.env.REACT_APP_EMAILJS_ADMIN_TEMPLATE_ID || 'YOUR_ADMIN_TEMPLATE_ID';

// Initialize EmailJS
if (EMAILJS_PUBLIC_KEY !== 'YOUR_EMAILJS_PUBLIC_KEY') {
  emailjs.init(EMAILJS_PUBLIC_KEY);
}

// Newsletter subscription using Mailchimp
export const subscribeToNewsletter = async (email) => {
  try {
    // For demo purposes, simulate success until serverless function is deployed
    console.log('Newsletter subscription for:', email);
    
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    /* For now, return success (replace with actual API call when deployed)
    return { 
      success: true, 
      message: 'Demo mode: Email would be added to newsletter list when Mailchimp is configured.' 
    };
    */

    // Uncomment below when your serverless function is deployed
    
    const response = await fetch('/.netlify/functions/subscribe', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email }),
    });

    if (!response.ok) {
      throw new Error('Failed to subscribe');
    }

    return { success: true };
    
  } catch (error) {
    console.error('Newsletter subscription error:', error);
    return { success: false, error: error.message };
  }
};

// Contact form submission using EmailJS - sends to admin only
export const sendContactForm = async (formData) => {
  try {
    // Check if EmailJS is properly configured
    if (EMAILJS_PUBLIC_KEY === 'YOUR_EMAILJS_PUBLIC_KEY' || !EMAILJS_PUBLIC_KEY) {
      console.warn('EmailJS not configured. Please set up your EmailJS credentials.');
      // For demo purposes, simulate success
      return { 
        success: true, 
        message: 'Demo mode: Contact form would be sent via EmailJS when configured.' 
      };
    }

    // Determine lead type based on form mode
    const leadType = formData.mode === 'demo' ? 'Demo Request' : 'Contact Request';

    const templateParams = {
      lead_type: leadType,
      lead_name: formData.name,
      lead_email: formData.email,
      lead_company: formData.company || 'Not provided',
      lead_role: formData.role || 'Not provided',
      lead_message: formData.message || '',
      timestamp: new Date().toLocaleString('en-US', { 
        timeZone: 'Asia/Kolkata',
        dateStyle: 'full',
        timeStyle: 'long'
      }),
      to_email: 'support@nthralabs.com',
    };

    const response = await emailjs.send(
      EMAILJS_SERVICE_ID,
      ADMIN_TEMPLATE_ID,
      templateParams
    );

    return { success: true, response };
  } catch (error) {
    console.error('Contact form error:', error);
    return { success: false, error: error.message };
  }
};

// Whitepaper download request - sends email to user and notification to admin
export const sendWhitepaperRequest = async (formData) => {
  try {
    // Check if EmailJS is properly configured
    if (EMAILJS_PUBLIC_KEY === 'YOUR_EMAILJS_PUBLIC_KEY' || !EMAILJS_PUBLIC_KEY) {
      console.warn('EmailJS not configured. Simulating success for demo.');
      await new Promise(resolve => setTimeout(resolve, 1000));
      return { 
        success: true, 
        message: 'Demo mode: Whitepaper emails would be sent via EmailJS when configured.' 
      };
    }

    // Template params for user email (with download link)
    const userTemplateParams = {
      to_name: formData.name,
      to_email: formData.email,
      company: formData.company || 'your company',
      role: formData.role || '',
      whitepaper_url: `${window.location.origin}/whitepaper.pdf`,
      website_url: window.location.origin,
    };

    // Template params for admin notification
    const adminTemplateParams = {
      lead_type: 'Whitepaper Download',
      lead_name: formData.name,
      lead_email: formData.email,
      lead_company: formData.company || 'Not provided',
      lead_role: formData.role || 'Not provided',
      lead_message: '', // No message for whitepaper downloads
      timestamp: new Date().toLocaleString('en-US', { 
        timeZone: 'Asia/Kolkata',
        dateStyle: 'full',
        timeStyle: 'long'
      }),
      to_email: 'support@nthralabs.com',
    };

    // Send email to user
    const userEmailResponse = await emailjs.send(
      EMAILJS_SERVICE_ID,
      WHITEPAPER_USER_TEMPLATE_ID,
      userTemplateParams
    );

    // Send notification to admin
    const adminEmailResponse = await emailjs.send(
      EMAILJS_SERVICE_ID,
      ADMIN_TEMPLATE_ID,
      adminTemplateParams
    );

    return { 
      success: true, 
      userEmail: userEmailResponse,
      adminEmail: adminEmailResponse 
    };
  } catch (error) {
    console.error('Whitepaper request error:', error);
    return { success: false, error: error.message };
  }
};